var React = require('react');

function StarUnselected (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M22.976 24.398C23.178 25.2628 22.2548 25.946 21.5098 25.4832L15.866 21.9767L10.2221 25.4832C9.47713 25.946 8.55394 25.2628 8.75587 24.398L10.2857 17.8468L5.26779 13.4628C4.60543 12.8841 4.95806 11.7786 5.82785 11.707L12.4172 11.1646L14.9598 4.94864C15.2954 4.12812 16.4365 4.12812 16.7721 4.94864L19.3148 11.1646L25.9041 11.707C26.7738 11.7786 27.1265 12.8841 26.4641 13.4628L21.4462 17.8468L22.976 24.398Z","fill":"black","fillOpacity":"0.1"}));
}

StarUnselected.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = StarUnselected;

StarUnselected.default = StarUnselected;
